const values = {
  COHERENCE_AND_COHESION: 'Coherence & Cohesion',
  GRAMMAR: 'Grammatical Range',
  OVERALL: 'Overall',
  TASK_ACHIEVEMENT: 'Task Achievement',
  VOCABULARY: 'Lexical Resource',
};

export const FeedbackTypeEnum = {
  COHERENCE_AND_COHESION: 'COHERENCE_AND_COHESION',
  GRAMMAR: 'GRAMMAR',
  OVERALL: 'OVERALL',
  TASK_ACHIEVEMENT: 'TASK_ACHIEVEMENT',
  VOCABULARY: 'VOCABULARY',
} as const;

export type FeedbackTypeEnum = (typeof FeedbackTypeEnum)[keyof typeof FeedbackTypeEnum];

export const getFeedbackTypeEnumTextByKey = (key) => {
  return values[key];
};
